import * as angular from "angular";

angular
  .module('bringoz.admin.tags')
  .config(TagsConfig);

function TagsConfig($stateProvider) {

  $stateProvider
    .state('tags', {
      parent: 'bringoz.site',
      url: '/tags',
      abstract: true,
      template: '<ui-view>'
    })
    .state('tags.table', {
      url: '/table',
      controllerAs: 'vm',
      reloadOnSearch: false,
      template: '<tags-view></tags-view>',
      controller: function (triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Tags"});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })


}
